import { render, staticRenderFns } from "./activity-collectCards.vue?vue&type=template&id=07562ff9&scoped=true&"
import script from "./activity-collectCards.vue?vue&type=script&lang=js&"
export * from "./activity-collectCards.vue?vue&type=script&lang=js&"
import style0 from "./activity-collectCards.vue?vue&type=style&index=0&id=07562ff9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07562ff9",
  null
  
)

export default component.exports